import { Link } from 'react-router-dom';
import { hotVideos } from '@/mocks/home';

const videoImages: Record<string, string> = {
  v1: "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20poster%20with%20space%20station%20and%20Earth%20in%20background%2C%20warm%20golden%20lighting%2C%20cinematic%20composition%2C%20minimalist%20design%2C%20clean%20dark%20background%20with%20orange%20accents%2C%20high%20detail%2C%208K%20quality&width=600&height=800&seq=hot-video-01&orientation=portrait",
  v2: "https://readdy.ai/api/search-image?query=Shanghai%201990s%20nostalgic%20drama%20poster%2C%20neon%20lights%20at%20night%2C%20urban%20atmosphere%2C%20warm%20amber%20tones%2C%20cinematic%20photography%20style%2C%20soft%20focus%20background%2C%20elegant%20composition%2C%208K%20quality&width=600&height=800&seq=hot-video-02&orientation=portrait",
  v3: "https://readdy.ai/api/search-image?query=Chinese%20mythology%20animated%20film%20poster%2C%20fire%20and%20water%20elements%20intertwining%2C%20dramatic%20lighting%2C%20epic%20fantasy%20atmosphere%2C%20warm%20orange%20and%20gold%20colors%2C%20cinematic%20rendering%2C%208K%20quality&width=600&height=800&seq=hot-video-03&orientation=portrait",
  v4: "https://readdy.ai/api/search-image?query=Chinese%20epic%20fantasy%20film%20poster%2C%20ancient%20Chinese%20palace%20silhouette%2C%20mystical%20clouds%20and%20golden%20light%2C%20dramatic%20composition%2C%20warm%20tone%2C%20cinematic%20atmosphere%2C%208K%20quality&width=600&height=800&seq=hot-video-04&orientation=portrait",
  v5: "https://readdy.ai/api/search-image?query=Crime%20thriller%20drama%20poster%2C%20urban%20night%20scene%20with%20rain%20on%20streets%2C%20moody%20atmospheric%20lighting%2C%20dark%20warm%20tones%2C%20cinematic%20film%20noir%20style%2C%20suspenseful%20composition%2C%208K%20quality&width=600&height=800&seq=hot-video-05&orientation=portrait",
  v6: "https://readdy.ai/api/search-image?query=Tang%20Dynasty%20Chinese%20animated%20film%20poster%2C%20ancient%20Changan%20city%20skyline%2C%20golden%20sunset%2C%20ink%20wash%20painting%20style%20blending%20with%203D%2C%20poetic%20atmosphere%2C%20warm%20amber%20tones%2C%208K%20quality&width=600&height=800&seq=hot-video-06&orientation=portrait",
  v7: "https://readdy.ai/api/search-image?query=Historical%20drama%20film%20poster%2C%20atomic%20age%20aesthetic%2C%20dramatic%20explosion%20silhouette%20in%20warm%20orange%20and%20dark%20contrast%2C%20minimalist%20cinematic%20design%2C%20intense%20atmosphere%2C%208K%20quality&width=600&height=800&seq=hot-video-07&orientation=portrait",
  v8: "https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%2C%20breathtaking%20landscape%20with%20mountains%20and%20ocean%2C%20golden%20hour%20lighting%2C%20warm%20natural%20tones%2C%20aerial%20photography%20style%2C%20serene%20epic%20composition%2C%208K%20quality&width=600&height=800&seq=hot-video-08&orientation=portrait",
};

export default function HotVideosSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10 md:mb-14">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
              热门推荐
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              大家都在看的高分影视作品
            </p>
          </div>
          <Link
            to="/category/dianying"
            className="whitespace-nowrap hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {hotVideos.map((video) => (
            <Link
              key={video.id}
              to={`/category/${getCategorySlug(video.category)}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3 bg-background-200">
                <img
                  src={videoImages[video.id]}
                  alt={video.title}
                  title={`${video.title} - 芒果视频高清在线观看`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
                    <i className="ri-play-fill text-lg"></i>
                  </div>
                </div>
                <div className="absolute top-2 right-2 bg-background-900/70 backdrop-blur-sm text-accent-400 text-xs font-semibold px-2 py-1 rounded-md">
                  {video.rating}
                </div>
              </div>
              <h3 className="font-semibold text-foreground-800 text-sm md:text-base truncate group-hover:text-primary-500 transition-colors">
                {video.title}
              </h3>
              <div className="flex items-center gap-2 mt-1 text-xs text-foreground-400">
                <span className="bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full text-xs">
                  {video.category}
                </span>
                <span>{video.views}次播放</span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/dianying"
            className="whitespace-nowrap inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}

function getCategorySlug(category: string): string {
  const map: Record<string, string> = {
    '电影': 'dianying',
    '电视剧': 'dianshiju',
    '综艺': 'zongyi',
    '动漫': 'dongman',
    '纪录片': 'jilupian',
  };
  return map[category] || 'dianying';
}